import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_ACCESS} from '../../constants';

export default {
  id: 'PARAM_COMPT',
  title: 'Comment modifier mes informations personnelles ?',
  description: '',
  categories: [CONTENT_CATEGORY_ACCESS],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Pour modifier vos informations personnelles, cliquez sur le bonhomme en bas à gauche'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_PARAM_COMPT/FR_PARAM_COMPT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Puis cliquez sur « Informations personnelles »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_PARAM_COMPT/FR_PARAM_COMPT_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Vous pouvez alors mettre à jour vos informations personnelles, puis valider'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_PARAM_COMPT/FR_PARAM_COMPT_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Pour des raisons de sécurité, notez que :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- La personne ayant le rôle Manager de compte ne peut pas modifier l’ensemble de ses informations personnelles'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- La personne qui dispose de la signature électronique des documents ne peut pas modifier l’ensemble de ses informations personnelles.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Pour cela il peut effectuer une demande au Service Clients.'
  }]
};
